/** 浏览器标签页默认标题（与 vue.config.js html 插件保持一致） */
export const APP_DOCUMENT_TITLE = '沁尔康智饮云管理系统'

/** 路由 name → 页面标题（用于 document.title 前缀） */
const ROUTE_NAME_TITLE = {
  Login: '登录',
  Dashboard: '工作台',
  ProductCategory: '产品分类',
  ProductSeries: '产品系列',
  ProductUnit: '产品单位',
  ProductTag: '产品标签',
  ProductBrand: '产品品牌',
  ServicePackageBenefit: '服务包权益',
  ProductSpec: '产品规格',
  ProductDeviceType: '设备类型管理',
  ProductDevicePowerSupply: '设备电源功率管理',
  ProductDeviceTankCapacity: '设备水箱容量管理',
  ProductDeviceFaucetCombo: '设备龙头组合管理',
  ProductList: '设备/滤芯/配件',
  ProductAdd: '添加产品',
  ProductEdit: '编辑产品',
  WorkorderPrice: '工单服务价格',
  ProductLinkDevice: '关联设备',
  WaterPackageList: '水量包产品',
  WaterPackageAdd: '创建水量包',
  WaterPackageEdit: '编辑水量包',
  WaterPackageUserPrice: '水量包用户价格',
  ServicePackageList: '服务包产品',
  ServicePackageAdd: '创建服务包',
  ServicePackageEdit: '编辑服务包',
  BundleProductList: '组合产品',
  BundleProductAdd: '创建组合产品',
  BundleProductEdit: '编辑组合产品',
  UserList: '用户列表',
  UserCreate: '创建用户',
  UserEdit: '编辑用户',
  UserDetail: '用户详情',
  ContractDetail: '合同详情',
  ContractTrafficDetail: '合同流量详情',
  ContractServiceDetail: '合同服务详情',
  OrderDetail: '订单详情',
  OrderApprovalFlowList: '审批流程设置',
  OrderApprovalFlowAdd: '创建审批流',
  OrderApprovalFlowEdit: '编辑审批流',
  RechargeOrderList: '充值订单',
  RechargeOrderDetail: '充值订单详情',
  LeaseRenewalOrderList: '租赁续费订单',
  LeaseRenewalOrderDetail: '续费订单详情',
  CancelOrderList: '取消订单',
  CancelOrderDetail: '取消订单详情',
  BundleProductOrderList: '组合产品订单',
  BundleProductOrderAdd: '新建组合产品订单',
  BundleProductOrderDetail: '组合产品订单详情',
  BundleProductOrderEdit: '编辑组合产品订单',
  ServicePackageOrderList: '服务包订单',
  ServicePackageOrderAdd: '新建服务包订单',
  ServicePackageOrderDetail: '服务包订单详情',
  SpShipmentApplicationList: '服务包订单发货申请',
  SpShipmentApplicationDetail: '发货申请详情',
  SalesOutboundList: '销售出库单明细',
  SalesOutboundDetail: '出库单详情',
  ProductOrderList: '产品订单',
  ProductOrderAdd: '新建产品订单',
  ProductOrderDetail: '产品订单详情',
  ProductOrderEdit: '编辑产品订单',
  UserLevel: '用户等级',
  UserCategory: '用户类别',
  UserIndustry: '用户行业',
  UserTag: '用户标签',
  UserProperty: '用户性质',
  UserSourceChannel: '用户来源渠道',
  DealerLevel: '经销商等级',
  DealerBenefit: '经销商权益',
  DealerCategory: '经销商类别',
  DealerSourceChannel: '经销商来源渠道',
  DealerIndustry: '经销商行业',
  DealerProperty: '经销商性质',
  DealerList: '经销商列表',
  DealerCreate: '创建经销商',
  DealerEdit: '编辑经销商',
  DealerDetail: '经销商详情',
  DealerContractList: '合同管理',
  DealerContractDetail: '合同详情',
  DealerTerminationList: '经销商解约管理',
  LeadReportList: '线索报备',
  OperationsAnalysis: '运维分析',
  DepartmentManage: '部门与员工',
  RoleManage: '角色管理',
  RolePermissionAssign: '分配权限',
  EmployeeManage: '员工管理',
  AccountManage: '账号管理',
  EmployeeTargetManage: '业务目标设置',
  TargetSettings: '目标设置',
  AreaManage: '区域管理',
  LargeAreaManage: '大区管理',
  OtherSettings: '其他设置',
  LoginLogManage: '登录日志',
  OperationLogManage: '操作日志',
  InvoiceList: '发票',
  WorkorderManage: '工单管理',
  ServiceWorkorder: '服务工单',
  ServiceWorkorderDetail: '工单详情',
  ServiceSettlement: '工单结算',
  EngineerManage: '工程师管理',
  EngineerLevel: '工程师等级',
  DispatcherManage: '执行人管理',
  ServiceSubject: '服务科目',
  WorkorderTag: '工单标签',
  AfterSaleCategory: '售后类别管理',
  AfterSalesManage: '售后申请管理',
  ComplaintManage: '投诉管理',
  IotContractManage: '合约管理',
  IotContractDetail: '合约详情',
  IotTerminationReasonManage: '解约原因管理',
  TrafficPoolManage: '流量池管理',
  TrafficRecharge: '流量充值',
  DeviceInstall: '设备安装',
  DeviceManage: '设备管理',
  ProtocolManage: '协议查询',
  InstructionSetManage: '指令集管理',
  IotLogManage: '指令日志',
}

/**
 * 根据当前路由更新 document.title
 * @param {import('vue-router').Route} route
 */
export function syncDocumentTitle(route) {
  const metaTitle = route.meta && route.meta.title
  const page = metaTitle || (route.name ? ROUTE_NAME_TITLE[route.name] : null)
  document.title = page ? `${page} - ${APP_DOCUMENT_TITLE}` : APP_DOCUMENT_TITLE
}
